// extracted by mini-css-extract-plugin
module.exports = {"main":"loader_main__1DzEl","loading":"loader_loading__3vXHk","rotation":"loader_rotation__7OFTX"};